import { useId } from 'react';

type GaleonProps = {
  vela: string;
  casco: string;
  bandera: string;
  /** Foto de portada pintada en las velas. */
  foto?: string | null;
  /** Nombre en la bandera del palo mayor (presupuesto compartido). */
  etiqueta?: string | null;
  width?: number;
};

/**
 * Galeón de tres palos del puerto, el mismo dibujo de la maqueta que eligió
 * Vadik (11-oct-2026). Dibujo propio.
 */
export function Galeon({
  vela,
  casco,
  bandera,
  foto,
  etiqueta,
  width = 120,
}: GaleonProps) {
  const id = useId().replace(/:/g, '');
  const relleno = foto ? `url(#foto-${id})` : vela;
  const texto =
    etiqueta && etiqueta.length > 14 ? `${etiqueta.slice(0, 13)}…` : etiqueta;
  return (
    <svg
      viewBox="0 0 120 100"
      width={width}
      height={(width * 100) / 120}
      aria-hidden
      style={{ overflow: 'visible' }}
    >
      {foto && (
        <defs>
          <pattern
            id={`foto-${id}`}
            patternUnits="userSpaceOnUse"
            x="20"
            y="10"
            width="80"
            height="52"
          >
            <image
              href={foto}
              width="80"
              height="52"
              preserveAspectRatio="xMidYMid slice"
            />
          </pattern>
        </defs>
      )}
      <g fill="#cfe9dc">
        <rect x="31" y="14" width="2.4" height="52" />
        <rect x="59" y="5" width="2.6" height="61" />
        <rect x="87" y="18" width="2.4" height="48" />
      </g>
      <g fill={relleno}>
        <path d="M22 20 Q32 24 43 20 L44 36 Q32 40 21 36 Z M21 40 Q32 44 44 40 L45 56 Q32 60 20 56 Z" />
        <path d="M47 12 Q60 17 73 12 L75 32 Q60 37 45 32 Z M45 36 Q60 41 75 36 L77 56 Q60 61 43 56 Z" />
        <path d="M79 24 Q88 27 97 24 L98 38 Q88 41 78 38 Z M78 42 Q88 45 98 42 L99 56 Q88 59 77 56 Z" />
      </g>
      <path d="M91 18 L116 58 L101 58 Z" fill={vela} opacity="0.75" />
      {texto ? (
        <g>
          <path
            d={`M61 -9 H${66 + largoBandera(texto)} l-4 5 l4 5 H61 Z`}
            fill={bandera}
          />
          <text
            x="64"
            y="-1.6"
            fontSize="7.5"
            fontWeight="700"
            fill="#fff"
            fontFamily="Manrope, system-ui, sans-serif"
          >
            {texto}
          </text>
          <rect x="59" y="-9" width="2.6" height="14" fill="#cfe9dc" />
        </g>
      ) : (
        <path d="M60.5 5 L73 8.5 L60.5 12 Z" fill={bandera} />
      )}
      <g fill={casco}>
        <path d="M6 66 L6 55 L28 55 L30 65 Z" />
        <path d="M6 66 L114 62 L104 80 Q60 90 18 82 Z" />
      </g>
      <g fill="#0f3b3a">
        <circle cx="30" cy="72" r="2" />
        <circle cx="45" cy="73" r="2" />
        <circle cx="60" cy="73" r="2" />
        <circle cx="75" cy="72" r="2" />
        <circle cx="90" cy="71" r="2" />
      </g>
    </svg>
  );
}

/** Ancho aproximado del texto de la bandera (7,5 px de letra). */
function largoBandera(texto: string): number {
  return texto.length * 4.6;
}
